import { FC, useContext } from 'react';
import styled from 'styled-components';
import { IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { CreateAccountContext } from './CreateAccountContext';

const BackButton = styled(IconButton)`
  position: absolute;
  left: 0;
  top: 0;
`;

const CreateAccountViewBody: FC = () => {
  const { currentStep, canGoToPreviousStep, goToPreviousStep } =
    useContext(CreateAccountContext);
  const { title, subtitle, StepBody } = currentStep;

  return (
    <Stack
      direction="column"
      gap={4}
      alignItems="center"
      sx={{ position: 'relative' }}
    >
      {canGoToPreviousStep && (
        <Tooltip title="Back" arrow placement="top" enterDelay={1000}>
          <BackButton onClick={goToPreviousStep}>
            <ArrowBack color="primary" />
          </BackButton>
        </Tooltip>
      )}
      <Stack gap={1}>
        <Typography variant="h4" textAlign="center">
          {title}
        </Typography>
        <Typography textAlign="center">{subtitle}</Typography>
      </Stack>
      <StepBody />
    </Stack>
  );
};

export default CreateAccountViewBody;
